import { render, staticRenderFns } from "./CBSPaydirectTable.vue?vue&type=template&id=84fe9688&"
import script from "./CBSPaydirectTable.vue?vue&type=script&lang=js&"
export * from "./CBSPaydirectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports